import { Component, Input, EventEmitter, Output } from '@angular/core';
import { BlockComponent } from '../block-organizer';

@Component({
  standalone: false,
  selector: 'blanksForm-block',
  templateUrl: './blanksForm-block.component.html',
  styleUrls: ['../tileblocks.component.scss', './blanksForm-block.component.scss']
})
export class BlanksFormBlockComponent implements BlockComponent {
  @Input() block: any;
  @Output() blanksFormView = new EventEmitter<any>();
  widget_Buttons_map = ['tile_open', 'tile_close', 'dial', 'email'];
  constructor() { }

  public onChange(data) {
    this.block.data.text = data;
    this.blanksFormView.emit({ 'action': 'blanksFormView', block: this.block });
  }
}
